import {HttpErrorResponse} from '@angular/common/http';
import {Component,ElementRef,OnInit,ViewChild} from '@angular/core';
import {ActivatedRoute,ParamMap,Router} from '@angular/router';
import {IMyDpOptions} from 'mydatepicker';
import {JhiAlertService} from 'ng-jhipster';
import {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {GooglePlaceDirective} from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import {BrokerCertificateService} from 'src/app/client/broker-get-certificate/broker-get-certificate.service';
import {CertificateMySuffixService} from 'src/app/client/certificate/certicate-my-suffix.service';
import {Principal,StateStorageService} from 'src/app/core';
import {MessageConst} from 'src/app/shared/constants/message.constants';
import {TdisConstants} from 'src/app/shared/constants/tdis-constants';
import {currenyMaskService} from 'src/app/shared/currencyMask.service';
import {OrderPipe} from 'src/app/shared/custom-pipe/order.pipe';
import {CertifiCargoDetails,CertifiShipmentDetails,CertificateRequestDto,CertificateTradeDetails} from 'src/app/shared/model/certificate-trade-details.model';
import {ClientDTO,TypeOfClient} from 'src/app/shared/model/client.model';
import {LocationMySuffix} from 'src/app/shared/model/location-mysuffix.model';
import {MeansOfConveyance} from 'src/app/shared/model/means-of-conveyance.model';
import {PolicyMarketType} from 'src/app/shared/model/policy-my-suffix.model';
import {RouterExtService} from 'src/app/shared/router-ext-service';
import {LanguageChangeService} from 'src/app/shared/services/language-change.service';
import {CommonUtils} from 'src/app/shared/util/common-utils';
import {RoleUtil} from 'src/app/shared/util/role-util';
import {CurrencyService} from '../currency';
import {LoadingTypeMySuffixService} from '../loading-type-my-suffix';
import {PortMySuffixService} from '../port-my-suffix/port-my-suffix.service';
import {User} from './../../core/user/user.model';
import {VesselInformationMySuffixService} from './../../entities/vessel-information-my-suffix/vessel-information-my-suffix.service';
import {ICountryMySuffix} from './../../shared/model/country-my-suffix.model';
import {CountryMySuffixService} from './../country-my-suffix/country-my-suffix.service';
import {BulkDeclarationService} from './bulk-declaration.service';
declare let $: any;

export class MocObj {
    name: string;
    value: MeansOfConveyance

    constructor() {
    }

}

@Component({
    selector: 'jhi-bulk-declaration-shipment',
    templateUrl: './bulk-declaration-shipment.component.html',
    styles: [],
    providers: [
        OrderPipe
    ]
})
export class BulkDeclarationShipmentComponent implements OnInit {

    @ViewChild("places") places: GooglePlaceDirective;
    @ViewChild("search") public searchElement: ElementRef;
    @ViewChild("vesselNameModal") vesselNameModal: ModalDirective;
    @ViewChild("vesselMandatoryModal") vesselMandatoryModal: ModalDirective;
    @ViewChild("vesselOptionalModal") vesselOptionalModal: ModalDirective;

    certificateRequestDto: CertificateRequestDto;
    isSumInsuredDisable: boolean;
    tradeDetails: CertificateTradeDetails;
    cargoDetail: CertifiCargoDetails;
    shippingDetail: CertifiShipmentDetails = new CertifiShipmentDetails();
    lossPayee: any;
    account: any;
    numberPattern = '^[0-9]+(.[0-9]{0,9})?$';
    imoAvailableCheck = false;

    isaddressDisabled: boolean = false;
    loadingTypeBaesOnMoc = new Map();
    isFromStationAddressDisabled: boolean = false;
    isFinalDestinationDisabled = false;
    istoStationAddressDisabled = false;
    selectedTypeOfMoc = 'VESSEL';

    disableNext1 = false;
    disableNext2 = false;
    disableNext3 = false;
    disableNext4 = false;

    bsConfig: Partial<BsDatepickerConfig>;
    searchText: string;
    productName = 'MARINE CARGO INSURANCE';
    loadingTypeList = [];
    subLoadingtypeList = [];
    packingTypeList = [];
    packingTypeObj: any = [];
    loadingTypeObj: any = [];
    isCertificateDTOAvailable = false;
    ReviseCertificateData: any;
    amountOptions: any;
    isSubType = false;
    isImoSelected: boolean;
    isVesselName: boolean;
    cargoList = [];
    isLoader = false;
    datePickerOptions: IMyDpOptions = {
        dateFormat: "dd/mm/yyyy",
    };
    loadingSettings = {
        singleSelection: true,
        text: 'Select Loading Type',
        allowSearchFilter: true,
        classes: 'myclass custom-class',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen: false
    };
    cargoSettings = {
        singleSelection: true,
        text: 'Select Cargo',
        allowSearchFilter: true,
        classes: 'myclass custom-class',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen: false
    };
    subLoadingSettings = {
        singleSelection: true,
        text: 'Select Sub Loading Type',
        allowSearchFilter: true,
        classes: 'myclass custom-class',
        idField: 'id',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen: false
    };
    packingSettings = {
        singleSelection: true,
        text: 'Select Packing Type',
        allowSearchFilter: true,
        classes: 'myclass custom-class',
        textField: 'name',
        closeDropDownOnSelection: true,
        defaultOpen: false
    };
    dischargeSettings = {
        singleSelection: true,
        text: "Select Port Of Discharge",
        allowSearchFilter: true,
        closeDropDownOnSelection: true,
        classes: "myclass custom-class",
        labelKey: "portOfCounrty",
        textField: "name",
        defaultOpen: false
    };

    currencyList: any;
    portList: any;
    portLoadingList: any;
    portDischargeList: any;
    dateOfShipment: any;
    istypeOfClientTrader: boolean;
    policyCurreny: any;

    previousUrl: any;
    page = 0;
    // size = 20;
    size = 50;
    private isApiCalled: boolean = true;
    private vesselDataLoaded: boolean = false;
    isVoyageNoEnabled = false;
    mocList: MocObj[] = [];
    policyType: PolicyMarketType;

    isPolCountryAddressDisabled = false;
    isPodCountryAddressDisabled = false;

    countries: ICountryMySuffix[] = [];
    polUnknownCountry = []
    podUnknownCountry = []

    countryDropdownSettings = {
        singleSelection: true,
        searchPlaceholderText: 'Select Country',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        defaultOpen: false
    };

    stateDropdownSettings = {
        singleSelection: true,
        searchPlaceholderText: 'Select State',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        allowSearchFilter: true,
        idField: 'id',
        textField: 'name',
        defaultOpen: false
    };

    states = [];
    polStateObj: any;
    podStateObj: any;
    isPolStateEnabled = false;
    isPodStateEnabled = false;

    sumInsuredLimitInCargoDetails: any;

    cargoSamInsuredData: number[] = [100];
    isVesselNameOrImoMandatoryEnabled=false;
    vesselImoOrNameOrUnknownValue: string = "name";

    readonly TdisConstants = TdisConstants;
    readonly RoleUtil = RoleUtil;

    constructor(
        private bulkDeclarationService: BulkDeclarationService,
        private jhiAlertService: JhiAlertService,
        private principal: Principal,
        private router: Router,
        private currenyMask: currenyMaskService,
        private stateStorageService: StateStorageService,
        private brokerCertificateService: BrokerCertificateService,
        private vesselInformationMySuffixService: VesselInformationMySuffixService,
        private certificateService: CertificateMySuffixService,
        private currencyService: CurrencyService,
        private portMySuffixService: PortMySuffixService,
        private loadingTypeService: LoadingTypeMySuffixService,
        private orderPipe: OrderPipe,
        private routerExtService: RouterExtService,
        private languageChangeService: LanguageChangeService,
        private activatedRoute: ActivatedRoute,
        private countryService: CountryMySuffixService

    ) {
        this.languageChangeService.refreshLanguage();
        this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {

                this.languageChangeService.refreshLanguage();
                window.history.back();
            }
        });
    }

    previousState() {
        window.history.back();
    }

    ngOnInit() {
        this.previousUrl = this.routerExtService.getPreviousUrl();
        this.selectedTypeOfMoc = TdisConstants.MeansOfConveyance.VESSEL;
        const typeOfClient = this.stateStorageService.getTypeOfClient();
        if (typeOfClient === TypeOfClient.TRADER) {
            this.istypeOfClientTrader = true;
        } else {
            this.istypeOfClientTrader = false;
        }

        this.countryService.query().subscribe(c => this.countries = c.body);  // getting countries

        this.certificateRequestDto = new CertificateRequestDto();
        this.certificateRequestDto.tradeDetailsDTO = new CertificateTradeDetails();
        this.certificateRequestDto.cargoDetailsDTO = new CertifiCargoDetails();
        this.certificateRequestDto.shipmentDetailsDTO = new CertifiShipmentDetails();

        this.certificateRequestDto.tradeDetailsDTO.product = TdisConstants.Product.MARINE_CARGO_INSURANCE;
        this.certificateRequestDto.cargoDetailsDTO.percentageCover = '110';

        if (this.certificateRequestDto.tradeDetailsDTO.product === TdisConstants.Product.MARINE_CARGO_INSURANCE) {
            this.sumInsuredLimitInCargoDetails = 110;
        }
        // this.shipmentDetails = new BulkDeclarationDto();

        this.amountOptions = this.currenyMask.amountPrecisionOptions;
        let data = null;
        // this.isFinalDestinationDisabled = true;
        // if (typeof this.stateStorageService.getClientDTO() === 'string') {
        if (CommonUtils.isString(this.stateStorageService.getClientDTO())) {
            data = JSON.parse(this.stateStorageService.getClientDTO());
        } else {
            data = this.stateStorageService.getClientDTO();
        }

        if(CommonUtils.isNil(data)) {
            // if still at this point then it means that clientDTO is not available, try to get it from session storage
            let revise=this.stateStorageService.getBulkCertificateDTO();
            let ob;
            if(CommonUtils.isNil(revise) && RoleUtil.isClient(this.principal.userIdentity.role)) {
                ob={
                    id: this.principal.userIdentity.policyHolderId,
                    typeOfClient: this.principal.userIdentity.typeOfClient
                }
            }else{
                ob={
                    id: revise.clientId,
                    typeOfClient: revise.typeOfClient
                }
            }
            data=ob;
        }

        // this.isVesselName = false;
        this.getCurrencyList();
        this.getCargotList(data);
        this.getMOCList(data);
        this.getPolicyEsgAwareness();

        this.account = this.principal.userIdentity;
        if (!this.account.policyCurrency) {
            // if (typeof this.stateStorageService.getClientDTO() === 'string') {
            if (CommonUtils.isString(this.stateStorageService.getClientDTO())) {
                this.brokerCertificateService.clientDto = JSON.parse(this.stateStorageService.getClientDTO());
            } else {
                this.brokerCertificateService.clientDto = this.stateStorageService.getClientDTO();
            }

            if (this.brokerCertificateService.clientDto) {
                // if (this.brokerCertificateService.clientDto.user == null) {
                if (CommonUtils.isNil(this.brokerCertificateService.clientDto.user)) {
                    this.brokerCertificateService.clientDto.user = new User();
                }
                this.account.policyCurrency = this.brokerCertificateService.clientDto.user
                    ? this.brokerCertificateService.clientDto.user.policyCurrency
                    : null;
                this.account.policyCurrencyValue = this.brokerCertificateService.clientDto.user
                    ? this.brokerCertificateService.clientDto.user.policyCurrencyValue
                    : null;
            }

        }

        this.policyCurreny = this.account.policyCurrency ? this.account.policyCurrency : '';
        // if (this.policyCurreny != '') {
        if (!CommonUtils.isNil(this.policyCurreny)) {
            this.certificateRequestDto.cargoDetailsDTO.currency = this.policyCurreny;
            this.certificateRequestDto.cargoDetailsDTO.clientPolicyCurreny = this.policyCurreny;
        }

        this.bsConfig = Object.assign(
            {},
            {
                containerClass: "custom-datepicker-theme",
                showWeekNumbers: false,
                dateInputFormat: "DD/MM/YYYY"
            }
        );



        // initial method to get certificateData
        this.ReviseCertificateData = this.stateStorageService.getBulkCertificateDTO();
        console.warn(this.ReviseCertificateData);
        this.getCargoSumInsuredLimitFromPolicy();
        console.log("certificate data", this.ReviseCertificateData);
        if (this.ReviseCertificateData) {
            this.isCertificateDTOAvailable = true;
            this.selectedTypeOfMoc = this.ReviseCertificateData.shipmentDetailsDTO.meansOfConveynace;
            let pofdSameAsPOD = this.ReviseCertificateData.shipmentDetailsDTO.isPOFDSameAsPOD;
            if (CommonUtils.isTrue(pofdSameAsPOD)) {
                this.ReviseCertificateData.shipmentDetailsDTO.isPOFDSameAsPOD = false;
                this.ReviseCertificateData.shipmentDetailsDTO.finalDestination = null;
            }

            let pooSameAsPOL = this.ReviseCertificateData.shipmentDetailsDTO.isPOOSameAsPOL;
            if (CommonUtils.isTrue(pooSameAsPOL)) {
                this.ReviseCertificateData.shipmentDetailsDTO.isPOOSameAsPOL = false;
                this.ReviseCertificateData.shipmentDetailsDTO.placeOfOrigin = null;
            }
            this.setFormData(this.ReviseCertificateData);

            if (this.ReviseCertificateData.shipmentDetailsDTO.isPolUnknown && this.ReviseCertificateData.shipmentDetailsDTO.polPortCountry) {
                this.isPolCountryAddressDisabled = true;
            }
            if (this.ReviseCertificateData.shipmentDetailsDTO.isPodUnknown && this.ReviseCertificateData.shipmentDetailsDTO.podPortCountry) {
                this.isPodCountryAddressDisabled = true;
            }

            if (this.certificateRequestDto.tradeDetailsDTO.product === TdisConstants.Product.MARINE_CARGO_INSURANCE) {
                this.getCargoSumInsuredLimitFromPolicy();
            }

            if(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL && this.certificateRequestDto.shipmentDetailsDTO.isImoAvailable){
                this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown = false;
            }
        } else {
            this.isCertificateDTOAvailable = false;
        }

        if (!this.isCertificateDTOAvailable) {
            this.getLoadingTypeList(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace);
        }

        this.getPortList();
        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace) {
            this.getAllPortsBasedOnMOC(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace)
        }

        // this.jhiAlertService.error(null, null, null);
        this.checkForVoyegaNumberEnabled();
        if(this.shippingDetail.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL){
            this.checkForVesselNameOrImoMandatoryEnabled();
        }
    }

    setLoadingTypeAndPackingTypes() {

        if (this.isCertificateDTOAvailable) {
            if (this.ReviseCertificateData && this.certificateRequestDto.cargoDetailsDTO.loadingTypeObj) {
                this.certificateRequestDto.cargoDetailsDTO.loadingTypeObj = this.certificateRequestDto.cargoDetailsDTO.loadingTypeObj;
            } else {
                this.certificateRequestDto.cargoDetailsDTO.loadingTypeObj = [this.ReviseCertificateData.cargoDetailsDTO.loadingTypeDTO];
            }

            if (this.ReviseCertificateData && this.certificateRequestDto.cargoDetailsDTO.packingTypeObj) {
                this.certificateRequestDto.cargoDetailsDTO.packingTypeObj = this.certificateRequestDto.cargoDetailsDTO.packingTypeObj;
            } else {
                this.certificateRequestDto.cargoDetailsDTO.packingTypeObj = [this.ReviseCertificateData.cargoDetailsDTO.packingTypeDTO];
            }
        }
    }

    addSumInsuredValue() {
        let sumInsredValue;
        if (this.certificateRequestDto.cargoDetailsDTO.percentageCover === '102') {
            const rem = this.certificateRequestDto.cargoDetailsDTO.cargoValue * (2 / 100);
            sumInsredValue = Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) + Number(rem);
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = sumInsredValue.toFixed(2);
        } else if (this.certificateRequestDto.cargoDetailsDTO.percentageCover === '105') {
            const rem = this.certificateRequestDto.cargoDetailsDTO.cargoValue * (5 / 100);
            sumInsredValue = Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) + Number(rem);
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = sumInsredValue.toFixed(2);
        } else if (this.certificateRequestDto.cargoDetailsDTO.percentageCover === '110') {
            const rem = this.certificateRequestDto.cargoDetailsDTO.cargoValue * (10 / 100);
            sumInsredValue = Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) + Number(rem);
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = sumInsredValue.toFixed(2);
        } else if (this.certificateRequestDto.cargoDetailsDTO.percentageCover === "120") {
            const rem =
                this.certificateRequestDto.cargoDetailsDTO.cargoValue * (20 / 100);
            // this.certificateRequestDto.cargoDetailsDTO.sumInsured =
            //     Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) +
            //     Number(rem);
            sumInsredValue = Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) + Number(rem);
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = sumInsredValue.toFixed(2);

        } else if (
            this.certificateRequestDto.cargoDetailsDTO.percentageCover === "130"
        ) {
            const rem =
                this.certificateRequestDto.cargoDetailsDTO.cargoValue * (30 / 100);
            // this.certificateRequestDto.cargoDetailsDTO.sumInsured =
            //     Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) +
            //     Number(rem);
            sumInsredValue = Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) + Number(rem);
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = sumInsredValue.toFixed(2);
        } else if (
            this.certificateRequestDto.cargoDetailsDTO.percentageCover === "140"
        ) {
            const rem =
                this.certificateRequestDto.cargoDetailsDTO.cargoValue * (40 / 100);
            // this.certificateRequestDto.cargoDetailsDTO.sumInsured =
            //     Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) +
            //     Number(rem);
            sumInsredValue = Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) + Number(rem);
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = sumInsredValue.toFixed(2);
        } else if (
            this.certificateRequestDto.cargoDetailsDTO.percentageCover === "150"
        ) {
            const rem =
                this.certificateRequestDto.cargoDetailsDTO.cargoValue * (50 / 100);
            // this.certificateRequestDto.cargoDetailsDTO.sumInsured =
            //     Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) +
            //     Number(rem);
            sumInsredValue = Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue) + Number(rem);
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = sumInsredValue.toFixed(2);
        }
        else if (this.certificateRequestDto.cargoDetailsDTO.percentageCover === '100') {
            const rem = this.certificateRequestDto.cargoDetailsDTO.cargoValue * (10 / 100);
            sumInsredValue = Number(this.certificateRequestDto.cargoDetailsDTO.cargoValue);
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = sumInsredValue.toFixed(2);
        }
        else {
            this.certificateRequestDto.cargoDetailsDTO.sumInsured = Number(
                this.certificateRequestDto.cargoDetailsDTO.cargoValue
            );
        }
    }

    getCargotList(clientInfo: any) {

        // if (clientInfo === null) {
        let id: number = clientInfo && clientInfo.id;
        if (CommonUtils.isNil(clientInfo)) {
            clientInfo = this.principal.userIdentity;
            id = clientInfo.policyHolderId;
        }
     if (CommonUtils.isNotNil(clientInfo) && CommonUtils.isNotNil(clientInfo.typeOfClient) && clientInfo.typeOfClient === TypeOfClient.TRADER) {
            this.certificateService.queryWithId('/bulk-get-cargo-list-info', id).subscribe(res => {
                let cargoList = [...res.payload];
                this.cargoList = this.orderPipe.transform(cargoList, 'name', false, true);
                console.log(this.cargoList);
                if (this.ReviseCertificateData) {
                    if (this.ReviseCertificateData && this.certificateRequestDto.cargoDetailsDTO.cargoObj) {
                        this.certificateRequestDto.cargoDetailsDTO.cargoObj = this.certificateRequestDto.cargoDetailsDTO.cargoObj;
                    } else {
                        this.certificateRequestDto.cargoDetailsDTO.cargoObj = [this.ReviseCertificateData.cargoDetailsDTO.cargoGroupDTO];
                    }
                }

            });
        }
    }

    // getCargotListById(clientId: any) {
    //     this.certificateService.queryWithId('/get-cargo-list-info', clientId).subscribe(res => {
    //         this.cargoList = res.payload;
    //         console.log(this.cargoList);
    //         if (this.ReviseCertificateData) {
    //             if (this.ReviseCertificateData && this.certificateRequestDto.cargoDetailsDTO.cargoObj) {
    //                 this.certificateRequestDto.cargoDetailsDTO.cargoObj = this.certificateRequestDto.cargoDetailsDTO.cargoObj;
    //             } else {
    //                 this.certificateRequestDto.cargoDetailsDTO.cargoObj = [this.ReviseCertificateData.cargoDetailsDTO.cargoGroupDTO];
    //             }
    //         }

    //     });
    // }

    checkUserType(product) {
        if (product === TdisConstants.Product.MARINE_CARGO_INSURANCE) {
            // this.certificateRequestDto.cargoDetailsDTO.percentageCover = '110';
            this.certificateRequestDto.cargoDetailsDTO.percentageCover = '110';
            if (this.certificateRequestDto.cargoDetailsDTO.cargoValue) {
                this.addSumInsuredValue();
            }
            this.isSumInsuredDisable = false;
            this.sumInsuredLimitInCargoDetails = 110;
            this.getCargoSumInsuredLimitFromPolicy()
        } else {
            //this.certificateRequestDto.cargoDetailsDTO.percentageCover = '100';
            this.certificateRequestDto.cargoDetailsDTO.percentageCover = '100';
            if (this.certificateRequestDto.cargoDetailsDTO.cargoValue) {
                this.addSumInsuredValue();
            }
            this.isSumInsuredDisable = true;
        }
    }

    onCargoSelect(event: any) {
        this.certificateRequestDto.cargoDetailsDTO.cargoId = this.certificateRequestDto.cargoDetailsDTO.cargoObj[0].id;
        // for (let i = 0; i < this.cargoList.length; i++) {
        //     if (event.id === this.cargoList[i].id) {
        //         this.certificateRequestDto.cargoDetailsDTO.cargoDescription = this.cargoList[i].description;
        //     }
        // }

        for (let _cargo of this.cargoList) {
            if (event.id === _cargo.id) {
                this.certificateRequestDto.cargoDetailsDTO.cargoDescription = _cargo.description;
            }
        }
    }


    onLoadingSelect(event: any) {

        this.certificateRequestDto.cargoDetailsDTO.loadingTypeId = this.certificateRequestDto.cargoDetailsDTO.loadingTypeObj[0].id;
        this.certificateRequestDto.cargoDetailsDTO.subTypeId = null;
        this.certificateRequestDto.cargoDetailsDTO.subTypeName = null;
        this.certificateRequestDto.cargoDetailsDTO.subTypeObj = [];
        this.certificateRequestDto.cargoDetailsDTO.packingTypeObj = [];

        // for (let i = 0; i < this.loadingTypeList.length; i++) {
        //     if (event.id === this.loadingTypeList[i].id) {
        //         this.isSubType = this.loadingTypeList[i].isSubType;
        //         /* if no subtype avilable packing types will be avilable at zero index of loadingSubType */
        //         if (this.isSubType) {
        //             this.subLoadingtypeList = this.loadingTypeList[i].loadingSubTypeDto
        //         } else {
        //             this.packingTypeList = this.loadingTypeList[i].loadingSubTypeDto[0].packingTypes;
        //         }
        //     }
        // }

        for (let _loadingTypeList of this.loadingTypeList) {
            if (event.id === _loadingTypeList.id) {
                this.isSubType = _loadingTypeList.isSubType;
                /* if no subtype avilable packing types will be avilable at zero index of loadingSubType */
                if (this.isSubType) {
                    this.subLoadingtypeList = _loadingTypeList.loadingSubTypeDto
                } else {
                    this.packingTypeList = _loadingTypeList.loadingSubTypeDto[0].packingTypes;
                }
            }
        }

        // for packing type list sorting
        let packingTypeList = [...this.packingTypeList];
        this.packingTypeList = this.orderPipe.transform(packingTypeList, 'name', false, true);

        let subLoadingtypeList = [...this.subLoadingtypeList];
        this.subLoadingtypeList = this.orderPipe.transform(subLoadingtypeList, 'name', false, true);
    }

    onLoadingDeSelect(event: any) {
        if (this.certificateRequestDto.cargoDetailsDTO.loadingTypeObj.length == 0) {
            this.isSubType = false;
        }
    }
    onSubLoadingSelect(event: any) {
        this.certificateRequestDto.cargoDetailsDTO.subTypeId = event.id;
        this.certificateRequestDto.cargoDetailsDTO.subTypeName = event.name;
        this.certificateRequestDto.cargoDetailsDTO.packingTypeObj = [];
        const selectedSubLoad = this.subLoadingtypeList.find(subLoading => subLoading.id == event.id);
        if (selectedSubLoad && selectedSubLoad.packingTypes) {
            this.packingTypeList = selectedSubLoad.packingTypes;
            // for packing type list sorting
            let packingTypeList = [...this.packingTypeList];
            this.packingTypeList = this.orderPipe.transform(packingTypeList, 'name', false, true);
        }
    }

    onPackingSelect(event: any) {
        this.certificateRequestDto.cargoDetailsDTO.packingTypeId = this.certificateRequestDto.cargoDetailsDTO.packingTypeObj[0].id;
    }

    getCurrencyList() {
        this.currencyService.query('/get-currency-list').subscribe(res => {
            this.currencyList = res.payload;
            console.log(this.currencyList);
        });
    }

    getPortList() {
        this.portMySuffixService.getAllPorts().subscribe(res => {
            this.portList = res.body;
            if (this.portList) {
                this.portList = this.portList.map(port => {
                    port.name = port.name + " ( " + port['countryDTO']['name'] + " )";
                    return port;
                });
                this.setPortDataUsingMOC(this.selectedTypeOfMoc);
            }
        });
    }

    // based on the MOC filtering the all ports
    /* typeOfMoc = SEA/ROAD/RAIL/AIR */
    getAllPortsBasedOnMOC(typeOfMoc) {

        if(CommonUtils.isNotNil(typeOfMoc) && typeOfMoc == TdisConstants.MeansOfConveyance.VESSEL){
            this.checkForVesselNameOrImoMandatoryEnabled();
        }

        if(this.selectedTypeOfMoc!=typeOfMoc) {
            this.selectedTypeOfMoc=typeOfMoc;

            this.certificateRequestDto.shipmentDetailsDTO.fromStation='';
            this.certificateRequestDto.shipmentDetailsDTO.fromStationCountry='';
            this.certificateRequestDto.shipmentDetailsDTO.toStation='';
            this.certificateRequestDto.shipmentDetailsDTO.toStationCountry='';
            this.istoStationAddressDisabled=false;
            this.isFromStationAddressDisabled=false;
            this.isaddressDisabled=false;
            this.isFinalDestinationDisabled=false;

            this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD=false;
            this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL=false;

            this.certificateRequestDto.shipmentDetailsDTO.vesselName = null;
            this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber="";
            this.certificateRequestDto.shipmentDetailsDTO.placeOfOrigin="";
            this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginCountry=null;
            this.certificateRequestDto.shipmentDetailsDTO.finalDestination="";
            this.certificateRequestDto.shipmentDetailsDTO.finalDestinationCountry=null
            this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingObj=[];
            this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeObj=[];

            this.certificateRequestDto.cargoDetailsDTO.loadingTypeObj=[ ...[] ];
            this.certificateRequestDto.cargoDetailsDTO.subTypeObj=[ ...[] ];
            this.certificateRequestDto.cargoDetailsDTO.packingTypeObj=[ ...[] ];
            this.certificateRequestDto.shipmentDetailsDTO.toStationStateAbbreviation=null;
            this.certificateRequestDto.shipmentDetailsDTO.fromStationStateAbbreviation=null;
            this.certificateRequestDto.shipmentDetailsDTO.placeOfFinalDestinationStateAbbreviation=null;
            this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginStateAbbreviation=null;
            this.getLoadingTypeList(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace);

            this.setPortDataUsingMOC(typeOfMoc);

            this.certificateRequestDto.shipmentDetailsDTO.toStationPlaceId=null;
            this.certificateRequestDto.shipmentDetailsDTO.fromStationPlaceId=null;
            this.certificateRequestDto.shipmentDetailsDTO.placeOfFinalDestinationPlaceId=null;
            this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginPlaceId=null;

            this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginLocation = new LocationMySuffix();
            this.certificateRequestDto.shipmentDetailsDTO.fromSeaOrRailOrAirportLocation = new LocationMySuffix();
            this.certificateRequestDto.shipmentDetailsDTO.toSeaOrRailOrAirportLocation = new LocationMySuffix();
            this.certificateRequestDto.shipmentDetailsDTO.finalDestinationLocation = new LocationMySuffix();

            this.polChange(); // remove selected port when moc changes
            this.certificateRequestDto.shipmentDetailsDTO.isPolUnknown=false;
            this.podChange();
            this.certificateRequestDto.shipmentDetailsDTO.isPodUnknown=false;
        }
    }

    setPortDataUsingMOC(typeOfMoc) {
        if (typeOfMoc === TdisConstants.MeansOfConveyance.VESSEL) {
            typeOfMoc = "SEA";
        } else {
            typeOfMoc = typeOfMoc;
            this.certificateRequestDto.shipmentDetailsDTO.voyageNumber = null;
        }
        let portsList = null;
        if (typeOfMoc !== "null") {
            if (this.portList) {
                portsList = this.portList.filter(obj => obj.portType === typeOfMoc);
            }
        }

        this.portLoadingList = portsList;
        this.portDischargeList = portsList;
    }



    blockSpecChars(event) {
        const charCode = event.which ? event.which : event.keyCode;

        if (
            (charCode >= 33 && charCode <= 47) ||
            (charCode >= 58 && charCode <= 64) ||
            (charCode >= 91 && charCode <= 96) ||
            (charCode >= 123 && charCode <= 126)
        ) {
            return false;
        } else {
            return true;
        }
    }

    getCountryLongName(value: any[]): string {
        let countryFullName;
        // for (let i = 0; i < value.length; i++) {
        //     console.log(value[i]);
        //     console.log(value[i].types.find(x => x === "country"));

        //     if (value[i].types.find(x => x === "country")) {
        //         countryFullName = value[i].long_name;
        //         console.log(countryFullName);

        //         // return value[i].long_name;
        //     }
        // }

        for (let _value of value) {
            console.log(_value);
            console.log(_value.types.find(x => x === "country"));

            if (_value.types.find(x => x === "country")) {
                countryFullName = _value.long_name;
                console.log(countryFullName);

                // return value[i].long_name;
            }
        }
        return countryFullName;
    }

    getCountryISO2(value: any[]): string {
        let iso;
        // for (let i = 0; i < value.length; i++) {
        //     console.log(value[i]);
        //     console.log(value[i].types.find(x => x === "country"));

        //     if (value[i].types.find(x => x === "country")) {
        //         iso = value[i].short_name;
        //         console.log(iso);

        //         // return value[i].short_name;
        //     }
        // }

        for (let _value of value) {
            console.log(_value);
            console.log(_value.types.find(x => x === "country"));

            if (_value.types.find(x => x === "country")) {
                iso = _value.short_name;
                console.log(iso);

                // return value[i].short_name;
            }
        }
        return iso;
    }

    handleLocation(location, address) {

        const formatted_country_adress = address.formatted_address.split(",");
        location.adress = address.formatted_address;
        location.longitude = address.geometry.location.lng()
        location.latitude = address.geometry.location.lat()
        location.placeId = address.place_id;
        location.countryName = this.getCountryLongName(
            address.address_components
        );
        location.countryISO = this.getCountryISO2(
            address.address_components
        );

            if (location.placeId == null || location.countryISO == null || location.latitude == null ||  location.longitude == null)
        {

            location.adress = null;
            this.onError("Please provide a precise location");
        }
    }

    handleLocationFromPort(location, port) {
        location.adress = port.location.adress;
        location.longitude = port.location.longitude;
        location.latitude = port.location.latitude;
        location.placeId = port.location.placeId;
        location.countryISO = port.location.countryISO;
        location.countryName = port.countryDTO.name;
    }

    public handlePlaceofOriginAddressChange(address) {
        this.isaddressDisabled = true;
        this.disableNext1 = false;
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOrigin = address.formatted_address;
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginCountry = this.getCountryISO2(
            address.address_components
        );
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginPlaceId = address.place_id;
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginStateAbbreviation = this.stateAbbreviation(address);
        this.handleLocation(this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginLocation, address);
        // check whether address contains any other characters rather than english
        // let addressArray = address.formatted_address.split('');
        // let checkStringContainNonAsciiCharacter = addressArray.some(char => char.charCodeAt(0) > 127);
        if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginCountry)) {
            this.certificateRequestDto.shipmentDetailsDTO.placeOfOrigin = null;
            this.isaddressDisabled = false;
            this.onError("Please provide a precise location")
        }
    }
    removeVesselName() {
        this.isImoSelected = true;
        this.certificateRequestDto.shipmentDetailsDTO.vesselName = undefined;
        this.vesselImoOrNameOrUnknownValue = "imo";
        this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown = false;
    }
    removeImoNumber() {
        this.isImoSelected = false;
        this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber = undefined;
        this.vesselImoOrNameOrUnknownValue="name";
        this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown = false;
    }
    maxLength: any;
    checkVesselImoLength(event) {

        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber) {
            this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber = this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber.trim();
        }

        if (event.target.value.length >= 7) {
            this.maxLength = 7;
            return false;
        }
    }

    onPasteVesselImo(event) {
        if (event.target.value) {
            this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber = this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber.trim();
            if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber.length >= 7) {
                this.maxLength = '';
                return false;
            }
        }
    }

    numberOnly(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode === 46) {
            return true;
        } else if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        } else {
            return true;
        }
    }

    trimBillOfLading(event) {
        if (this.certificateRequestDto.shipmentDetailsDTO.billingOfLoadingNumber) {
            this.certificateRequestDto.shipmentDetailsDTO.billingOfLoadingNumber = this.certificateRequestDto.shipmentDetailsDTO.billingOfLoadingNumber.trim();
            return false;
        }
    }


    getImoNumberData() {
        ///vessel-informations-imo
        localStorage.removeItem('imoNumbers')
        // if (this.certificateRequestDto.shipmentDetailsDTO.vesselName != undefined) {
        if (CommonUtils.isNotNil(this.certificateRequestDto.shipmentDetailsDTO.vesselName)) {
            // this.certificateRequestDto.shipmentDetailsDTO.vesselName= this.certificateRequestDto.shipmentDetailsDTO.vesselName.trim()
            // // this.vesselInformationMySuffixService.findImosByName(this.shippingDetail.vesselName).subscribe(data => {
            // this.vesselInformationMySuffixService.findIHSImosByName(this.certificateRequestDto.shipmentDetailsDTO.vesselName).subscribe(data => {
            //     console.log(data);
            //     localStorage.setItem('imoNumbers', JSON.stringify(data.body));
            // })
            this.page = 0;
            // this.size = 20;
            this.size = 50;
            this.vesselNameAndImoNumbers = [];
            this.getImoNumberDataPageable(this.page, this.size, false);
            // if(this.ihsTotalCount && this.ihsTotalCount > this.size) {
            //     this.getImoNumberDataPageable(this.page, this.size, false);
            //   } else {
            //     return;
            //   }
            this.vesselDataLoaded = false;
            this.isApiCalled = true;
        }
    }
    // this.getImoNumberDataPageable(this.page,this.size,false);
    ihsTotalCount: number = 0;
    getImoNumberDataPageable(page: number, size: number, flag: boolean) {
        this.vesselInformationMySuffixService.post("ihs-vessel-informations-detail/?page=" + page + "&size=" + size, { name: this.certificateRequestDto.shipmentDetailsDTO.vesselName }).subscribe(res => {
            let body = res.body;
            if(res && res.headers) {
                const xTotalCount = res.headers.get('X-Total-Count');
                if(typeof xTotalCount === 'string') {
                  this.ihsTotalCount = parseInt(xTotalCount);
                } else {
                  this.ihsTotalCount = xTotalCount;
                }
              }
            if (body && body.length > 0) {
                // this.vesselNameAndImoNumbers = [...body, ...this.vesselNameAndImoNumbers];
                this.vesselNameAndImoNumbers = [...this.vesselNameAndImoNumbers, ...body];
            } else {
                this.vesselDataLoaded = true;
            }

            if (flag) {
                this.isApiCalled = true;
            }
        }, err => { });
    }
    vesselNameIndexTrack(index: number) {
        return index;
    }
    onVesselModelScroll() {
        if (this.isApiCalled && !this.vesselDataLoaded) {
            this.isApiCalled = false;
            this.page++;
            if(this.ihsTotalCount && this.ihsTotalCount > this.size) {
                this.getImoNumberDataPageable(this.page, this.size, true);
              } else {
                return;
              }
        }
    }

    trimVesselImo(event) {
        if (event.target.value.length >= 7) {
            this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber = this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber.trim();
            return false;
        }
    }

    onPortOfLoadingSelect(event: any) {
       let te = this.portList.filter(obj => obj.id === event.id);
       this.handleLocationFromPort(this.certificateRequestDto.shipmentDetailsDTO.fromSeaOrRailOrAirportLocation, (this.portList.filter(obj => obj.id === event.id))[0]);
        this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingId = this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingObj[0].id;
        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace !== TdisConstants.MeansOfConveyance.VESSEL) {
            this.certificateRequestDto.shipmentDetailsDTO.placeOfOrigin = event.name;
        }

        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL && this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL) {
            this.copyPOLToPOOIfSame(this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL);
        }
        if (!this.isPlaceIdPresent(this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingId)) {
            //this.jhiAlertService.error("please update port of loading  and select again ");
            this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingObj = [];
            this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingId = null;
        }
    }
    onDischargeSelect(event: any) {
        this.handleLocationFromPort(this.certificateRequestDto.shipmentDetailsDTO.toSeaOrRailOrAirportLocation, (this.portList.filter(obj => obj.id === event.id))[0]);
        this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeId = this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeObj[0].id;
        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace !== TdisConstants.MeansOfConveyance.VESSEL) {
            this.certificateRequestDto.shipmentDetailsDTO.finalDestination = event.name;
        }
        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL && this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD) {
            this.copyPODToPOFDIfSame(this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD);
        }
        if (!this.isPlaceIdPresent(this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeId)) {
            // this.jhiAlertService.error("please update port of discharge  and select again ");
            this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeObj = [];
            this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeId = null;
        }
    }

    public handleFinalDestinationAddressChange(address) {
        this.isFinalDestinationDisabled = true;
        this.disableNext2 = false;
        this.certificateRequestDto.shipmentDetailsDTO.finalDestination = address.formatted_address;
        this.certificateRequestDto.shipmentDetailsDTO.finalDestinationCountry = this.getCountryISO2(
            address.address_components
        );
        this.certificateRequestDto.shipmentDetailsDTO.placeOfFinalDestinationPlaceId = address.place_id;
        this.certificateRequestDto.shipmentDetailsDTO.placeOfFinalDestinationStateAbbreviation = this.stateAbbreviation(address);
        this.handleLocation(this.certificateRequestDto.shipmentDetailsDTO.finalDestinationLocation, address);
        // check whether address contains any other characters rather than english
        // let addressArray = address.formatted_address.split('');
        // let checkStringContainNonAsciiCharacter = addressArray.some(char => char.charCodeAt(0) > 127);
        // if (this.certificateRequestDto.shipmentDetailsDTO.finalDestinationCountry == null) {
        if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.finalDestinationCountry)) {
            this.certificateRequestDto.shipmentDetailsDTO.finalDestination = null;
            this.isFinalDestinationDisabled = false;
            this.onError("Please provide a precise location")
        }
        // console.log(this.certificateRequestDto.shipmentDetailsDTO.finalDestinationCountry, "final dest");
    }

    hideVesselNameModel() {
        this.isImoSelected = false;
        this.vesselNameModal.hide();
    }
    onImoSubmit() {
        this.vesselNameModal.hide()
        this.onSubmit();
    }
    changeImoNumber(event,name) {

        this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber=event.target.value;
        this.certificateRequestDto.shipmentDetailsDTO.vesselName = name;
        this.isImoSelected = true;
    }

    public activePlaceOfOrigin($event) {
        this.isaddressDisabled = false;
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOrigin = null;
        this.disableNext1 = true;
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginCountry = null;
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginLocation = new LocationMySuffix();
    }

    public activeFinalDestination($event) {
        this.isFinalDestinationDisabled = false;
        this.certificateRequestDto.shipmentDetailsDTO.finalDestination = null;
        this.certificateRequestDto.shipmentDetailsDTO.finalDestinationCountry = null;
        this.disableNext2 = true;
        this.certificateRequestDto.shipmentDetailsDTO.finalDestinationLocation = new LocationMySuffix();
    }

    public handleFromStationAddressChange(address) {
        this.isFromStationAddressDisabled = true;
        this.disableNext3 = false;
        const fomStation = address.name;
        this.certificateRequestDto.shipmentDetailsDTO.fromStation = address.name;
        this.certificateRequestDto.shipmentDetailsDTO.fromStationCountry = this.getCountryISO2(
            address.address_components
        );
        this.handleLocation(this.certificateRequestDto.shipmentDetailsDTO.fromSeaOrRailOrAirportLocation, address);
        // check whether address contains any other characters rather than english
        // let addressArray = address.formatted_address.split('');
        // let checkStringContainNonAsciiCharacter = addressArray.some(char => char.charCodeAt(0) > 127);
        // if (this.certificateRequestDto.shipmentDetailsDTO.fromStationCountry == null) {
        if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.fromStationCountry)) {
            this.certificateRequestDto.shipmentDetailsDTO.fromStation = null;
            this.isFromStationAddressDisabled = false;
            this.onError("Please provide a precise location")
        }

        if (this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL) {
            this.copyFromToPOOIfSame(this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL);
        }
        this.certificateRequestDto.shipmentDetailsDTO.fromStationPlaceId = address.place_id;
        this.certificateRequestDto.shipmentDetailsDTO.fromStationStateAbbreviation = this.stateAbbreviation(address);
    }

    public handleToStationAddressChange(address) {
        this.istoStationAddressDisabled = true;
        this.disableNext4 = false;
        this.certificateRequestDto.shipmentDetailsDTO.toStation = address.name;
        this.certificateRequestDto.shipmentDetailsDTO.toStationCountry = this.getCountryISO2(
            address.address_components
        );
        this.handleLocation(this.certificateRequestDto.shipmentDetailsDTO.toSeaOrRailOrAirportLocation, address);
        // check whether address contains any other characters rather than english
        // let addressArray = address.formatted_address.split('');
        // let checkStringContainNonAsciiCharacter = addressArray.some(char => char.charCodeAt(0) > 127);
        // if (this.certificateRequestDto.shipmentDetailsDTO.toStationCountry == null) {
        if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.toStationCountry)) {
            this.certificateRequestDto.shipmentDetailsDTO.toStation = null;
            this.istoStationAddressDisabled = false;
            this.onError("Please provide a precise location")
        }
        if (this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD) {
            this.copyToToPOFDIfSame(this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD);
        }
        this.certificateRequestDto.shipmentDetailsDTO.toStationPlaceId = address.place_id;
        this.certificateRequestDto.shipmentDetailsDTO.toStationStateAbbreviation = this.stateAbbreviation(address);
    }

    public activeFromStation($event) {
        this.isFromStationAddressDisabled = false;
        this.certificateRequestDto.shipmentDetailsDTO.fromStation = null;
        this.certificateRequestDto.shipmentDetailsDTO.fromStationCountry = null;
        this.disableNext3 = true;
    }
    public activetoStation($event) {
        this.istoStationAddressDisabled = false;
        this.certificateRequestDto.shipmentDetailsDTO.toStation = null;
        this.certificateRequestDto.shipmentDetailsDTO.toStationCountry = null;
        this.disableNext4 = true;
    }

    changeShipMentDate(event) {
        // if (this.dateOfShipment != null) {
        if (CommonUtils.isNotNil(this.dateOfShipment)) {
            let shipmentDate = this.principal.dateFormateClientToServer(
                this.dateOfShipment.date
            );
            this.certificateRequestDto.shipmentDetailsDTO.dateOfShipment = shipmentDate;
        }
        if (CommonUtils.isNotNil(event) && CommonUtils.isNotNil(event.date) && event.date.year != 0) {
            let date = event.date;
            let dateStr = date.year + "-" + date.month + "-" + date.day;

            this.certificateRequestDto.shipmentDetailsDTO.dateOfShipment = dateStr;

            if (this.certificateRequestDto.tradeDetailsDTO.product === TdisConstants.Product.MARINE_CARGO_INSURANCE) {
                this.getCargoSumInsuredLimitFromPolicy();

            }
        } else {
            this.certificateRequestDto.cargoDetailsDTO.percentageCover = "100";
            this.addSumInsuredValue();
        }
    }

    onFromAirportSelect(event: any) { }
    onToAirportSelect(event: any) { }

    onFromTrainSelect(event: any) { }
    onToTrainSelect(event: any) { }

    onCancelVesselModel() {
        this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber = null;
        this.hideVesselNameModel();
    }

    vesselNameAndImoNumbers = [];
    onSubmit() {

        const IMO_NUMBER = this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber;

        if(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL && IMO_NUMBER && !CommonUtils.isNumber(IMO_NUMBER)) {
            this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber = null;
            this.jhiAlertService.error("The IMO should contain numbers only.");
            return;
        }

        if (!this.checkStateAbbrevationIsPresent()) {
            return;
        }

        if (!this.checkPlaceIdIsPresent()) {
            return;
        }

        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL) {
            if (this.certificateRequestDto.shipmentDetailsDTO.isPolUnknown) {
                if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.polPortCountry) || CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2)) {
                    this.jhiAlertService.error("please provide correct port of loading country ");
                    this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = null
                    this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 = null
                    this.certificateRequestDto.shipmentDetailsDTO.polPortCountryPlaceId = null
                    this.certificateRequestDto.shipmentDetailsDTO.polStateAbbreviation = null
                    return false;
                } else {
                    if (this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 == 'US' && (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.polStateAbbreviation) || !this.isPolStateEnabled)) {
                        this.jhiAlertService.error("please deselect POL United States and select state again");
                        return;
                    }
                }
            } else if (!this.isPlaceIdPresent(this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingId)) {
                //this.jhiAlertService.error("please update port of loading  and select again ");
                this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingObj = [];
                this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingId = null;
                return;
            }

            if (this.certificateRequestDto.shipmentDetailsDTO.isPodUnknown) {
                if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.podPortCountry) || CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2)) {
                    this.jhiAlertService.error("please provide correct place of origin ");
                    this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = null
                    this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2 = null
                    this.certificateRequestDto.shipmentDetailsDTO.podPortCountryPlaceId = null
                    this.certificateRequestDto.shipmentDetailsDTO.podStateAbbreviation = null
                    return false;
                } else {
                    if (this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2 == 'US' && (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.podStateAbbreviation) || !this.isPodStateEnabled)) {
                        this.jhiAlertService.error("please deselect POD United States and select state again");
                        return;
                    }
                }
            } else if (!this.isPlaceIdPresent(this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeId)) {
                // this.jhiAlertService.error("please update port of discharge and select again ");
                this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeObj = [];
                this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeId = null;
                return;
            }

            if (!this.certificateRequestDto.shipmentDetailsDTO.isPolUnknown) {    // is pol unknown not seleted
                this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = null
                this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 = null
                this.certificateRequestDto.shipmentDetailsDTO.polPortCountryPlaceId = null
                this.certificateRequestDto.shipmentDetailsDTO.polStateAbbreviation = null
            } else {
                this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingObj = [];
                this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingId = null;
                this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingDTO = null;
            }

            if (!this.certificateRequestDto.shipmentDetailsDTO.isPodUnknown) {  // if pod unknow not selected
                this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = null
                this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2 = null
                this.certificateRequestDto.shipmentDetailsDTO.podPortCountryPlaceId = null
                this.certificateRequestDto.shipmentDetailsDTO.podStateAbbreviation = null
            } else {
                this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeObj = [];
                this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeId = null;
                this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeDTO = null;
            }


        }

        console.log(this.certificateRequestDto);
        if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber) && this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL) {
            // this.vesselNameAndImoNumbers = JSON.parse(localStorage.getItem("imoNumbers"));
            if (CommonUtils.isNil(this.vesselNameAndImoNumbers) || this.vesselNameAndImoNumbers.length > 0) {
                if (!this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && (CommonUtils.isNil(this.isImoSelected) || CommonUtils.isFalse(this.isImoSelected))) {
                    this.vesselNameModal.show();
                    $(".width-10 input[type='radio']").prop('checked', false)
                    // move scroll bar top of the div
                    setTimeout(() => {
                        let myDiv = document.getElementById('focusDiv');
                        myDiv.scrollTop = 0;
                    }, 1000);
                    return;
                }
            }
        }

        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber) {
            this.certificateRequestDto.shipmentDetailsDTO.isImoAvailable = true;
        } else {
            this.certificateRequestDto.shipmentDetailsDTO.isImoAvailable = false;
        }

        if (this.certificateRequestDto.shipmentDetailsDTO.isImoAvailable) {
            this.imoAvailableCheck = false;
          } else if (!this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown){
            this.imoAvailableCheck = true;
          }

        //check ISO numbers exit for locations
        let shippingDetail = this.certificateRequestDto.shipmentDetailsDTO;

        if (shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL) {
            if ((shippingDetail.placeOfOrigin && !shippingDetail.placeOfOriginCountry) || (shippingDetail.finalDestination && !shippingDetail.finalDestinationCountry)) {
                this.onError("Please provide a precise location");
                return;
            }

        } else if (shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.RAIL || shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.AIR) {
            if ((shippingDetail.placeOfOrigin && !shippingDetail.placeOfOriginCountry) || (shippingDetail.finalDestination && !shippingDetail.finalDestinationCountry) || (shippingDetail.fromStation && !shippingDetail.fromStationCountry) || (shippingDetail.toStation && !shippingDetail.toStationCountry)) {
                this.onError("Please provide a precise location");
                return;
            }

            // for air and rail from and to station/ from airport and to airport should not be same
            if (this.certificateRequestDto.shipmentDetailsDTO.fromStation == this.certificateRequestDto.shipmentDetailsDTO.toStation) {
                if (shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.RAIL) {
                    this.onError("From station and To station should not be same");
                    return;
                } else {
                    this.onError("From Airport and To Airport should not be same");
                    return;
                }
            }


        } else if (shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.ROAD) {
            if (shippingDetail.placeOfOriginCountry && shippingDetail.finalDestinationCountry) {
            } else {
                this.onError("Please provide a precise location");
                return;
            }
        }
        // this.getImoNumberData();
        if (!(this.certificateRequestDto.shipmentDetailsDTO.isPolUnknown || this.certificateRequestDto.shipmentDetailsDTO.isPodUnknown) &&
            this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL &&
            this.certificateRequestDto.shipmentDetailsDTO.portOfLoadingId ===
            this.certificateRequestDto.shipmentDetailsDTO.portOfDischargeId
        ) {
            this.onError("Port of Loading and Discharge should not be same");
        } else {


            if (this.certificateRequestDto.tradeDetailsDTO.product == TdisConstants.Product.MARINE_CARGO_INSURANCE) {
                this.certificateRequestDto.tradeDetailsDTO.clientType = 'Seller';
                this.certificateRequestDto.tradeDetailsDTO.incoterms = TdisConstants.IncoTerms.CIF;

            } else if (this.certificateRequestDto.tradeDetailsDTO.product == TdisConstants.Product.SELLERS_INTEREST) {
                this.certificateRequestDto.tradeDetailsDTO.clientType = 'Seller';
                this.certificateRequestDto.tradeDetailsDTO.incoterms = TdisConstants.IncoTerms.FOB;

            } else if (this.certificateRequestDto.tradeDetailsDTO.product == TdisConstants.Product.BUYERS_INTEREST) {
                this.certificateRequestDto.tradeDetailsDTO.clientType = 'Buyer';
                this.certificateRequestDto.tradeDetailsDTO.incoterms = TdisConstants.IncoTerms.CIF;
            }

            let shipmentDate = this.principal.dateFormateClientToServer(
                this.dateOfShipment.date
            );

            this.certificateRequestDto.shipmentDetailsDTO.dateOfShipment = shipmentDate;

            if (
                this.principal.userIdentity.authorities[0] === "BROKER" ||
                this.principal.userIdentity.authorities[0] === "BROKER_STAFF" ||
                this.principal.userIdentity.authorities[0] === "INSURER" ||
                this.principal.userIdentity.authorities[0] === "INSURER_STAFF" ||
                this.principal.userIdentity.authorities[0] === "UNDERWRITER" ||
                this.principal.userIdentity.authorities[0] === "UNDERWRITER_STAFF"
            ) {
                // assigning clientId from service when broker creates the crertificate
                // if (this.brokerCertificateService.clientDto != null) {
                if (!CommonUtils.isNil(this.brokerCertificateService.clientDto)) {
                    console.log(
                        "brokerCertificateService",
                        this.brokerCertificateService.clientDto
                    );
                    this.certificateRequestDto.clientId = this.brokerCertificateService.clientDto.id;
                } else {
                    let clientInfo = this.stateStorageService.getClientDTO();
                    // if (typeof clientInfo === "string") {
                    if (CommonUtils.isString(clientInfo)) {
                        clientInfo = JSON.parse(this.stateStorageService.getClientDTO());
                    }
                    this.certificateRequestDto.clientId = clientInfo.id;
                }
            }

            // adding revised ID to the final DTO
            const certificateData = this.stateStorageService.getCertificateDTO();
            if (this.isCertificateDTOAvailable) {
                this.certificateRequestDto.revisedFromCertificateRequestId =
                    certificateData.id;
                this.certificateRequestDto.clientId = certificateData.clientId;
                this.certificateRequestDto.tradeDetailsDTO.id = null;
                this.certificateRequestDto.cargoDetailsDTO.id = null;
                this.certificateRequestDto.shipmentDetailsDTO.id = null;
            }
            // this.certificateRequestDto.previousDeclarationRequestId =certificateData.previousDeclarationRequestId;

            console.log(this.certificateRequestDto);
            this.certificateRequestDto.tradeDetailsDTO.coAssuredPolicyHolder = null;

            // this.save();
            this.vesselUnknownMandatoryOptionalModals();
        }

    }

    private onError(errorMessage: string) {
        this.isLoader = false;
        this.jhiAlertService.error(errorMessage, null, null);
        return;
    }


    save() {
        this.isLoader = true;
        // this.isSaving = true;
        // if (this.certificateRequestDto.id !== undefined) {
        if (CommonUtils.isNotNil(this.certificateRequestDto.id)) {
            this.bulkDeclarationService.update(this.certificateRequestDto);
        } else {
            this.bulkDeclarationService.create(this.certificateRequestDto).subscribe(
                data => {
                    // console.log(data.body);
                    const response = data.body;
                    if (CommonUtils.isSame(response.status, MessageConst.SUCCESS)) {
                        // clearing the certificate DTO list and other tab details
                        this.stateStorageService.resetBulkCertificateDTO();
                        this.jhiAlertService.success(response.message, null, null);
                        localStorage.removeItem("scopeList");
                        localStorage.setItem("scopeList", JSON.stringify(response.payload));
                        this.router.navigateByUrl("/my-declaration/scopes");
                        // if(this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && this.principal.userIdentity.isVesselNameOrImoMandatory) {
                        //     this.vesselMandatoryModal.show();
                        // } else if(this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && !this.principal.userIdentity.isVesselNameOrImoMandatory) {
                        //     this.vesselOptionalModal.show();
                        // } else {
                        //     this.router.navigateByUrl("/my-declaration/scopes");
                        // }
                        this.isLoader = false;
                    } else {
                        // clearing the certificate DTO list and other tab details
                        this.stateStorageService.resetBulkCertificateDTO();
                        //
                        if (response.messages != "NO SCOPES FOUND") {
                            this.jhiAlertService.error(response.messages, null, null);
                        }
                        this.router.navigateByUrl("/my-declaration/no-scope");
                        // if(this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && this.principal.userIdentity.isVesselNameOrImoMandatory) {
                        //     this.vesselMandatoryModal.show();
                        // } else if(this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && !this.principal.userIdentity.isVesselNameOrImoMandatory) {
                        //     this.vesselOptionalModal.show();
                        // } else {
                        //     this.router.navigateByUrl("/my-declaration/no-scope");
                        // }
                        this.isLoader = false;
                    }
                    // close alert manually
                    setTimeout(() => {
                        this.principal.closeAlertManually(this.jhiAlertService);
                    }, 5000);
                },
                (res: HttpErrorResponse) => this.onError(res.error.message)
            );
        }
    }


    setFormData(certificateData) {
        let clientDto = new ClientDTO();
        clientDto.id = certificateData.clientId;
        this.brokerCertificateService.clientDto = clientDto;
        this.tradeDetails = certificateData.tradeDetailsDTO;
        this.shippingDetail = certificateData.shipmentDetailsDTO;
        this.selectedTypeOfMoc = this.shippingDetail.meansOfConveynace;

        this.shippingDetail.portOfLoadingObj = [certificateData.shipmentDetailsDTO.portOfLoadingDTO];

        this.shippingDetail.portOfDischargeObj = [certificateData.shipmentDetailsDTO.portOfDischargeDTO];

        if (this.selectedTypeOfMoc == TdisConstants.MeansOfConveyance.VESSEL) {
            if (!this.shippingDetail.isPolUnknown) {
                this.shippingDetail.portOfLoadingObj[0]!.name = this.shippingDetail.portOfLoadingObj[0]!.name + " ( " + this.shippingDetail.portOfLoadingObj[0]!.countryName + " )";
            }

            if (!this.shippingDetail.isPodUnknown) {
                this.shippingDetail.portOfDischargeObj[0]!.name = this.shippingDetail.portOfDischargeObj[0]!.name + " ( " + this.shippingDetail.portOfDischargeObj[0]!.countryName + " )";
            }
        }

        if (certificateData.shipmentDetailsDTO.placeOfOrigin) {
            this.isaddressDisabled = true;
            this.disableNext1 = false;
        }
        if (certificateData.shipmentDetailsDTO.fromStation) {
            this.isFromStationAddressDisabled = true;
            this.disableNext3 = false;
        }
        if (certificateData.shipmentDetailsDTO.finalDestination) {
            this.isFinalDestinationDisabled = true;
            this.disableNext2 = false;
        }
        if (certificateData.shipmentDetailsDTO.toStation) {
            this.istoStationAddressDisabled = true;
            this.disableNext4 = false;
        }

        this.cargoDetail = certificateData.cargoDetailsDTO;
        // this.getCargotListById(certificateData.clientId);
        this.certificateService.get('api/get-loading-type-list/' + certificateData.shipmentDetailsDTO.meansOfConveynace).subscribe(res => {

            let loadingTypeList = [...res.body['payload']];
            this.loadingTypeList = this.orderPipe.transform(loadingTypeList, 'name', false, true);
            console.log(this.loadingTypeList, "this.loadingTypeList after pipe");

            if (this.isCertificateDTOAvailable) {
                if (this.ReviseCertificateData && this.cargoDetail.loadingTypeObj) {
                    this.cargoDetail.loadingTypeObj = this.cargoDetail.loadingTypeObj;
                } else {
                    this.cargoDetail.loadingTypeObj = [this.ReviseCertificateData.cargoDetailsDTO.loadingTypeDTO];
                }

                if (this.ReviseCertificateData && this.cargoDetail.packingTypeObj) {
                    this.cargoDetail.packingTypeObj = this.cargoDetail.packingTypeObj;
                } else {
                    this.cargoDetail.packingTypeObj = [this.ReviseCertificateData.cargoDetailsDTO.packingTypeDTO];
                }
            }
            //assign if favourite or revise case
            if (this.isCertificateDTOAvailable) {
                this.cargoDetail.loadingTypeObj = [];
                this.cargoDetail.subTypeObj = [];
                this.cargoDetail.packingTypeObj = [];

                for (let index = 0; index < this.loadingTypeList.length; index++) {
                    const element = this.loadingTypeList[index];

                    if (element.id == this.cargoDetail.loadingTypeId) {
                        this.cargoDetail.loadingTypeObj.push(element);
                        this.isSubType = element.isSubType;
                        if (element.isSubType == true) {
                            this.subLoadingtypeList = element.loadingSubTypeDto;
                            for (let st_index = 0; st_index < element.loadingSubTypeDto.length; st_index++) {
                                const loadingSubType = element.loadingSubTypeDto[st_index];
                                if (this.cargoDetail.subTypeId == loadingSubType.id) {
                                    this.cargoDetail.subTypeObj.push(loadingSubType);

                                    this.packingTypeList = loadingSubType.packingTypes;
                                    for (let pt_index = 0; pt_index < loadingSubType.packingTypes.length; pt_index++) {
                                        const packingType = loadingSubType.packingTypes[pt_index];


                                        if (packingType.id == this.cargoDetail.packingTypeId) {
                                            this.cargoDetail.packingTypeObj.push(packingType);
                                        }
                                    }
                                }
                            }
                        } else {
                            //no sub type
                            this.packingTypeList = element.loadingSubTypeDto[0].packingTypes
                            for (let pt_index = 0; pt_index < element.loadingSubTypeDto[0].packingTypes.length; pt_index++) {
                                const packingType = element.loadingSubTypeDto[0].packingTypes[pt_index];
                                if (packingType.id == this.cargoDetail.packingTypeId) {
                                    this.cargoDetail.packingTypeObj.push(packingType);
                                }
                            }
                        }
                    }
                }
                // for packing type list sorting
                let packingTypeList = [...this.packingTypeList];
                this.packingTypeList = this.orderPipe.transform(packingTypeList, 'name', false, true);
                let subLoadingtypeList = [...this.subLoadingtypeList];
                this.subLoadingtypeList = this.orderPipe.transform(subLoadingtypeList, 'name', false, true);
            }
        });

        //this.isaddressDisabled = true;
        //this.isFinalDestinationDisabled = true;
        this.certificateRequestDto.tradeDetailsDTO = this.tradeDetails;
        this.certificateRequestDto.cargoDetailsDTO = this.cargoDetail;
        this.certificateRequestDto.shipmentDetailsDTO = this.shippingDetail;

        if(this.certificateRequestDto && this.certificateRequestDto.shipmentDetailsDTO.vesselName === TdisConstants.VesselName.FIRST_CLASS_VESSEL) {
            this.certificateRequestDto.shipmentDetailsDTO.vesselName = null;
        }

        if(certificateData.shipmentDetailsDTO.meansOfConveyanceNumber && certificateData.shipmentDetailsDTO.vesselName){
            this.vesselImoOrNameOrUnknownValue="name";
          } else if(certificateData.shipmentDetailsDTO.isVesselUnknown){
            this.vesselImoOrNameOrUnknownValue="unknown";
          }else if(certificateData.shipmentDetailsDTO.meansOfConveyanceNumber){
            this.vesselImoOrNameOrUnknownValue="imo";
          }else if(certificateData.shipmentDetailsDTO.vesselName){
            this.vesselImoOrNameOrUnknownValue="name";
          }


        if (certificateData.shipmentDetailsDTO.vesselName) {
            // this.isVesselName = true;
            if (certificateData.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL) {
                this.removeImoNumber();
                this.getImoNumberData();
            }
        } else if (certificateData.shipmentDetailsDTO.meansOfConveyanceNumber) {
            // this.isVesselName = false;
        }
        // For disable the sum Insured
        if (this.certificateRequestDto.tradeDetailsDTO.product === TdisConstants.Product.MARINE_CARGO_INSURANCE) {
            this.isSumInsuredDisable = false;
        } else {
            this.isSumInsuredDisable = true;
        }

        this.certificateRequestDto.tradeDetailsDTO.id = null;
        this.certificateRequestDto.cargoDetailsDTO.id = null;
        this.certificateRequestDto.shipmentDetailsDTO.id = null;
        this.certificateRequestDto.shipmentDetailsDTO.dateOfShipment = null;

        this.certificateRequestDto.revisedFromCertificateRequestId = certificateData.id;
        this.certificateRequestDto.certificateRequestNumber = certificateData.certificateRequestNumber;

        if (certificateData.requestRevisionStatus == 'REQUEST_INIT' && certificateData.requestRevisionId) {
            this.certificateRequestDto.requestRevisionId = certificateData.requestRevisionId;
        }

        if (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL) {
            //  this.removeImoNumber();
            //  this.getImoNumberData();

            if (this.shippingDetail.isPolUnknown && this.shippingDetail.polPortCountry) {
                this.isPolCountryAddressDisabled = true;
                let con = this.countries.find(cn => cn.isoTwo == this.shippingDetail.polPortCountryIso2);
                if (CommonUtils.isNil(con)) {
                    this.polUnknownCountry = [];
                    this.isPolCountryAddressDisabled = false;
                } else {
                    this.shippingDetail.polPortCountry = con.name;
                    this.polUnknownCountry = [this.shippingDetail.polPortCountry];
                }


                this.polUnknownCountry = [this.shippingDetail.polPortCountry];
                if (this.shippingDetail.polPortCountryIso2 == 'US' && CommonUtils.isNotNil(con)) {
                    // let usCon=this.countries.find(cn => cn.isoTwo=='US');
                    let usCon = con;
                    // if (usCon != undefined) {
                    if (CommonUtils.isNotNil(usCon)) {
                        this.countryService.getStatesByCountryId(usCon.id).subscribe(res => {
                            let usState = res.body.find(s => s.abbreviation == this.shippingDetail.polStateAbbreviation);
                            this.isPolStateEnabled = true;
                            // if (usState != undefined) {
                            if (CommonUtils.isNotNil(usState)) {
                                this.shippingDetail.polStateAbbreviation = usState.name;
                                this.polStateObj = [usState];
                            } else {
                                this.polStateObj = [this.shippingDetail.polStateAbbreviation];
                            }
                        });
                    }

                }
            }
            if (this.shippingDetail.isPodUnknown && this.shippingDetail.podPortCountry) {
                this.isPodCountryAddressDisabled = true;
                let con = this.countries.find(cn => cn.isoTwo == this.shippingDetail.podPortCountryIso2);
                // if (con == undefined) {
                if (CommonUtils.isNil(con)) {
                    this.podUnknownCountry = [];
                    this.isPodCountryAddressDisabled = false;
                } else {
                    this.shippingDetail.podPortCountry = con.name;
                    this.podUnknownCountry = [this.shippingDetail.podPortCountry];
                }

                if (this.shippingDetail.podPortCountryIso2 == 'US' && CommonUtils.isNotNil(con)) {
                    // let usCon=this.countries.find(cn => cn.isoTwo=='US');
                    let usCon = con;
                    // if (usCon != undefined) {
                    if (CommonUtils.isNotNil(usCon)) {
                        this.countryService.getStatesByCountryId(usCon.id).subscribe(res => {
                            let usState = res.body.find(s => s.abbreviation == this.shippingDetail.podStateAbbreviation);
                            this.isPodStateEnabled = true;
                            // if (usState != undefined) {
                            if (CommonUtils.isNotNil(usState)) {
                                this.shippingDetail.podStateAbbreviation = usState.name;
                                this.podStateObj = [usState];
                            } else {
                                this.podStateObj = [this.shippingDetail.podStateAbbreviation];
                            }
                        });
                    }
                }
            }

        }
    }

    getLoadingTypeList(moc) {
        let flag = this.loadingTypeBaesOnMoc.has(moc)
        let data = null;
        if (flag) {
            data = this.loadingTypeBaesOnMoc.get(moc);
            // if (data == null) {
            if (CommonUtils.isNil(data)) {
                this.loadingTypeList = [];
            } else {
                this.loadingTypeList = data;
            }
            let loadingTypeList = [...this.loadingTypeList];
            this.loadingTypeList = this.orderPipe.transform(loadingTypeList, 'name', false, true);
        } else {
            data = this.loadingTypeBaesOnMoc.set(moc, null);
            this.loadingTypeService.get('get-loading-type-list/' + moc).subscribe(res => {
                data = res.body['payload'];
                this.loadingTypeBaesOnMoc.set(moc, data);
                let loadingTypeList = [...data];
                this.loadingTypeList = [];
                let sortedData = this.orderPipe.transform(loadingTypeList, 'name', false, true);
                this.loadingTypeList = [...this.loadingTypeList, ...sortedData]
                console.log(this.loadingTypeList, "this.loadingTypeList..............>>>>");

                this.setLoadingTypeAndPackingTypes();
            });
        }

        console.log(this.loadingTypeList, "this.loadingTypeList after pipe METGHOD");

    }

    trimVoyage(event) {
        if (this.certificateRequestDto.shipmentDetailsDTO.voyageNumber) {
            this.certificateRequestDto.shipmentDetailsDTO.voyageNumber = this.certificateRequestDto.shipmentDetailsDTO.voyageNumber.trim();
            return false;
        }
    }

    copyPODToPOFDIfSame(checked) {
        let shippingDetail = this.certificateRequestDto.shipmentDetailsDTO
        shippingDetail.finalDestination = null;
        shippingDetail.finalDestinationCountry = null;
        if (checked && shippingDetail.portOfDischargeObj && shippingDetail.portOfDischargeObj.length > 0) {
            shippingDetail.finalDestination = shippingDetail.portOfDischargeObj[0].name;
            this.disableNext2 = false;
        } else {
            this.disableNext2 = true;
            this.isFinalDestinationDisabled = false;
        }

    }

    copyPOLToPOOIfSame(checked) {
        let shippingDetail = this.certificateRequestDto.shipmentDetailsDTO;
        shippingDetail.placeOfOrigin = null;
        shippingDetail.placeOfOriginCountry = null;
        if (checked && shippingDetail.portOfLoadingObj && shippingDetail.portOfLoadingObj.length > 0) {
            shippingDetail.placeOfOrigin = shippingDetail.portOfLoadingObj[0].name;
            this.disableNext1 = false;
        } else {
            this.disableNext1 = true;
            this.isaddressDisabled = false;
        }

    }

    copyFromToPOOIfSame(checked) {

        let shippingDetail = this.certificateRequestDto.shipmentDetailsDTO;
        shippingDetail.placeOfOrigin = null;
        shippingDetail.placeOfOriginCountry = null;

        if (checked && shippingDetail.fromStationCountry && (shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.RAIL || shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.AIR)) {
            shippingDetail.placeOfOrigin = shippingDetail.fromStation;
            shippingDetail.placeOfOriginCountry = shippingDetail.fromStationCountry;
            this.disableNext3 = false;
        }
        else {
            this.disableNext1 = true;
            this.isaddressDisabled = false;
        }

    }
    copyToToPOFDIfSame(checked) {
        let shippingDetail = this.certificateRequestDto.shipmentDetailsDTO;
        shippingDetail.finalDestination = null;
        shippingDetail.finalDestinationCountry = null;
        if (checked && shippingDetail.toStationCountry && (shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.RAIL || shippingDetail.meansOfConveynace == TdisConstants.MeansOfConveyance.AIR)) {
            shippingDetail.finalDestination = shippingDetail.toStation;
            shippingDetail.finalDestinationCountry = shippingDetail.toStationCountry;
            this.disableNext4 = false;
        }
        else {
            this.disableNext2 = true;
            this.isFinalDestinationDisabled = false;
        }
    }


    public stateAbbreviation(address) {
        if (address) {
            // for (let index = 0; index < address.address_components.length; index++) {
            //     const element = address.address_components[index];

            //     if (element.types.includes('administrative_area_level_1')) {
            //         return element.short_name;
            //     }
            // }

            for (let _addressComponents of address.address_components) {

                if (_addressComponents.types.includes('administrative_area_level_1')) {
                    return _addressComponents.short_name;
                }
            }
            return null;
        }
    }

    checkPlaceIdIsPresent() {
        let shippingDetail = this.certificateRequestDto.shipmentDetailsDTO;
        // if (shippingDetail.placeOfOriginPlaceId == undefined && shippingDetail.placeOfOrigin && shippingDetail.meansOfConveynace != 'ROAD') {
        if (CommonUtils.isNil(shippingDetail.placeOfOriginPlaceId) && shippingDetail.placeOfOrigin && shippingDetail.meansOfConveynace != TdisConstants.MeansOfConveyance.ROAD) {
            this.jhiAlertService.error("please deselect place of origin and select again ");
            return false;
        }
        // if (shippingDetail.placeOfFinalDestinationPlaceId == undefined && shippingDetail.finalDestination && shippingDetail.meansOfConveynace != 'ROAD') {
        if (CommonUtils.isNil(shippingDetail.placeOfFinalDestinationPlaceId) && shippingDetail.finalDestination && shippingDetail.meansOfConveynace != TdisConstants.MeansOfConveyance.ROAD) {
            this.jhiAlertService.error("please deselect place of destination and select again ");
            return false;
        }
        switch (shippingDetail.meansOfConveynace) {


            case TdisConstants.MeansOfConveyance.RAIL:
            case TdisConstants.MeansOfConveyance.AIR:

                // if (shippingDetail.toStationPlaceId == undefined) {
                if (CommonUtils.isNil(shippingDetail.toStationPlaceId)) {
                    this.jhiAlertService.error("please deselect To Station/Airport and select again");
                    return false;
                }
                // if (shippingDetail.fromStationPlaceId == undefined) {
                if (CommonUtils.isNil(shippingDetail.fromStationPlaceId)) {
                    this.jhiAlertService.error("please deselect From Station/Airport and select again");
                    return false;
                }
                return true;

            default:
                return true;

        }



    }

    checkStateAbbrevationIsPresent() {
        let shippingDetail = this.certificateRequestDto.shipmentDetailsDTO;

        switch (shippingDetail.meansOfConveynace) {
            case TdisConstants.MeansOfConveyance.VESSEL:
            case TdisConstants.MeansOfConveyance.ROAD:
                if (shippingDetail.placeOfOriginCountry == 'US' && CommonUtils.isNil(shippingDetail.placeOfOriginStateAbbreviation) && !shippingDetail.isPOOSameAsPOL) {
                    this.jhiAlertService.error("please deselect United States and select again proper place instead of a country as a whole");
                    return false;
                }
                if (shippingDetail.finalDestinationCountry == 'US' && CommonUtils.isNil(shippingDetail.placeOfFinalDestinationStateAbbreviation) && !shippingDetail.isPOFDSameAsPOD) {
                    this.jhiAlertService.error("please deselect United States and select again proper place instead of a country as a whole");
                    return false;
                }
                return true;
            case TdisConstants.MeansOfConveyance.RAIL:
            case TdisConstants.MeansOfConveyance.AIR:
                if (shippingDetail.placeOfOriginCountry == 'US' && CommonUtils.isNil(shippingDetail.placeOfOriginStateAbbreviation) && !shippingDetail.isPOOSameAsPOL) {
                    this.jhiAlertService.error("please deselect United States and select again proper place instead of a country as a whole");
                    return false;
                }
                if (shippingDetail.finalDestinationCountry == 'US' && CommonUtils.isNil(shippingDetail.placeOfFinalDestinationStateAbbreviation) && !shippingDetail.isPOFDSameAsPOD) {
                    this.jhiAlertService.error("please deselect United States and select again proper place instead of a country as a whole");
                    return false;
                }

                // if (shippingDetail.toStationCountry == 'US' && shippingDetail.toStationStateAbbreviation == undefined) {
                if (shippingDetail.toStationCountry == 'US' && CommonUtils.isNil(shippingDetail.toStationStateAbbreviation)) {
                    this.jhiAlertService.error("please deselect United States and select again proper place instead of a country as a whole");
                    return false;
                }
                // if (shippingDetail.fromStationCountry == 'US' && shippingDetail.fromStationStateAbbreviation == undefined) {
                if (shippingDetail.fromStationCountry == 'US' && CommonUtils.isNil(shippingDetail.fromStationStateAbbreviation)) {
                    this.jhiAlertService.error("please deselect United States and select again proper place instead of a country as a whole");
                    return false;
                }
                return true;

            default:
                return true;
        }

    }

    replaceNumberFeomEnd(str: string) {
        if (str == undefined) return "";
        let s = str.replace(/[\d.-]/g, '');
        return s;
    }

    yearOfBuild(date) {
        if (date && date.length > 4) {
            return date.substring(0, 4);
        }
        return date;
    }
    isPlaceIdPresent(portId) {
        let existCOuntry = this.portList.find(({ id }) => portId == id);
        if (CommonUtils.isNil(existCOuntry) || CommonUtils.isNil(existCOuntry.location) || CommonUtils.isNil(existCOuntry.location.placeId)) {
            this.jhiAlertService.error("please update port '" + existCOuntry.name + "' and select again ");
            return false;
        }

        return true;

    }

    getMOCList(clientInfo: any) {

        let id;
        // if (clientInfo === null) {
        if (CommonUtils.isNil(clientInfo)) {
            id = this.principal.userIdentity.policyHolderId;
        } else {
            id = clientInfo.id
        }
        // if (clientInfo.typeOfClient === 'FREIGHT_FORWARDER') {
        //     this.certificateService.query('/get-moc-list-info').subscribe(res => {
        //         let mocList = [...res.payload];
        //
        //     });
        // } else if (clientInfo.typeOfClient === 'TRADER') {
        this.certificateService.queryWithId('/bulk/get-moc-list-info', id).subscribe(res => {
            this.policyType = res.payload.policyType;
            this.getMocMap(res.payload.mocs);

            if (this.policyType != PolicyMarketType.SPOT && this.mocList && this.mocList.length > 0 && CommonUtils.isNil(this.ReviseCertificateData)) {
                let moc: MocObj[] = this.mocList.filter(moc => moc.name == 'Vessel');
                if (moc && moc.length > 0) {
                    this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace = moc[0].value;
                } else {
                    this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace = this.mocList[0].value;
                }

                this.getLoadingTypeList(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace);
            }
        });
        // }
    }

    getPolicyEsgAwareness() {

        this.certificateService.get('api/policies/broker-underwriter-insurer/is-enable-esg-carboncare').subscribe(res => {
            this.certificateRequestDto.shipmentDetailsDTO.enableEsgCarboncare = res.body.enableEsgCarboncare;
            this.certificateRequestDto.shipmentDetailsDTO.enablePolicyEsgAwareness = res.body.enableEsgAwareness;
        }, err => {
            this.jhiAlertService.error(err.message)
        });
    }

    getMocMap(mocs) {
        mocs.forEach(moc => {
            let mocobj: MocObj = new MocObj();
            if (moc == MeansOfConveyance.AIR) {
                mocobj.name = 'Air';
                mocobj.value = MeansOfConveyance.AIR;
                this.mocList.push(mocobj)
            } else if (moc == MeansOfConveyance.RAIL) {
                mocobj.name = 'Rail';
                mocobj.value = MeansOfConveyance.RAIL;
                this.mocList.push(mocobj)
            } else if (moc == MeansOfConveyance.ROAD) {
                mocobj.name = 'Road';
                mocobj.value = MeansOfConveyance.ROAD;
                this.mocList.push(mocobj)
            } else if (moc == MeansOfConveyance.VESSEL) {
                mocobj.name = 'Vessel';
                mocobj.value = MeansOfConveyance.VESSEL;
                this.mocList.push(mocobj)
            }
        })
    }

    public handlePolCountryAddressChange(address) {
        // this.isPolCountryAddressDisabled = true;
        // this.disableNext3 = false;
        // this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = address.name;
        // this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 = this.getCountryISO2(
        //   address.address_components
        // );
        // // check whether address contains any other characters rather than english
        // // let addressArray = address.formatted_address.split('');
        // // let checkStringContainNonAsciiCharacter = addressArray.some(char => char.charCodeAt(0) > 127);
        // if( this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 == null){
        //   this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = null;
        //   this.isPolCountryAddressDisabled=false;
        //   this.onError("Please provide a precise location")
        // }
        // if(this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL){
        //   this.copyPolCountryToPOOIfSame(this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL);
        // }
        // this.certificateRequestDto.shipmentDetailsDTO.polPortCountryPlaceId = address.place_id;
        // this.certificateRequestDto.shipmentDetailsDTO.polStateAbbreviation = this.stateAbbreviation(address);


        this.disableNext3 = false;
        this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = address.name;

        let country: ICountryMySuffix = this.countries.find(c => address.id == c.id);

        if (CommonUtils.isNil(country)) {
            this.onError("Please select valid country");
        }

        this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 = country.isoTwo
        // check whether address contains any other characters rather than english
        // let addressArray = address.formatted_address.split('');
        // let checkStringContainNonAsciiCharacter = addressArray.some(char => char.charCodeAt(0) > 127);

        if (country.isoTwo == 'US') {
            this.getStatesByCountryId(country.id);
            this.isPolStateEnabled = true;
        } else {
            this.polStateObj = null;
            this.certificateRequestDto.shipmentDetailsDTO.polStateAbbreviation = null;
            this.isPolStateEnabled = false;
        }

        // if (this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 == null) {
        if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2)) {
            this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = null;
            this.isPolCountryAddressDisabled = false;
            this.onError("Please select valid country")
        }
        if (this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL) {
            this.copyPolCountryToPOOIfSame(this.certificateRequestDto.shipmentDetailsDTO.isPOOSameAsPOL);
        }

    }

    public activePolCountry($event) {
        this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 = null;
        this.isPolCountryAddressDisabled = false;
        this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = null;
        this.disableNext3 = true;
    }


    public handlePodCountryAddressChange(address) {
        // this.isPodCountryAddressDisabled = true;
        // this.disableNext3 = false;
        // this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = address.name;
        // this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2 = this.getCountryISO2(
        //   address.address_components
        // );
        // // check whether address contains any other characters rather than english
        // // let addressArray = address.formatted_address.split('');
        // // let checkStringContainNonAsciiCharacter = addressArray.some(char => char.charCodeAt(0) > 127);
        // if( this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2 == null){
        //   this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = null;
        //   this.isPodCountryAddressDisabled=false;
        //   this.onError("Please provide a precise location")
        // }
        // if(this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD){
        //   this.copyPodCountryToPOOIfSame(this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD);
        // }
        // this.certificateRequestDto.shipmentDetailsDTO.podPortCountryPlaceId = address.place_id;
        // this.certificateRequestDto.shipmentDetailsDTO.podStateAbbreviation = this.stateAbbreviation(address);

        this.disableNext3 = false;
        this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = address.name;
        let country: ICountryMySuffix = this.countries.find(c => address.id == c.id);

        // if (country == undefined) {
        if (CommonUtils.isNil(country)) {
            this.onError("Please select valid country");
        }
        this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2 = country.isoTwo

        // check whether address contains any other characters rather than english
        // let addressArray = address.formatted_address.split('');
        // let checkStringContainNonAsciiCharacter = addressArray.some(char => char.charCodeAt(0) > 127);

        if (country.isoTwo == 'US') {
            this.getStatesByCountryId(country.id);
            this.isPodStateEnabled = true;
        } else {
            this.podStateObj = null;
            this.certificateRequestDto.shipmentDetailsDTO.podStateAbbreviation = null;
            this.isPodStateEnabled = false;
        }

        if (CommonUtils.isNil(this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2)) {
            this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = null;
            this.isPodCountryAddressDisabled = false;
            this.onError("Please select valid country")
        }
        if (this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD) {
            this.copyPodCountryToPOOIfSame(this.certificateRequestDto.shipmentDetailsDTO.isPOFDSameAsPOD);
        }

    }

    public activePodCountry($event) {
        this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2 = null;
        this.isPodCountryAddressDisabled = false;
        this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = null;
        this.disableNext3 = true;
    }

    copyPolCountryToPOOIfSame(checked) {
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOrigin = null;
        this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginCountry = null;

        // this.shippingDetail.fromStation = address.name;
        // this.shippingDetail.fromStationCountry =

        if (checked && this.certificateRequestDto.shipmentDetailsDTO.polPortCountry && (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL)) {
            this.certificateRequestDto.shipmentDetailsDTO.placeOfOrigin = this.certificateRequestDto.shipmentDetailsDTO.polPortCountry;
            this.certificateRequestDto.shipmentDetailsDTO.placeOfOriginCountry = this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2;
            this.disableNext3 = false;
        }
        else {
            this.disableNext3 = true;
            this.isaddressDisabled = false;
        }

    }

    copyPodCountryToPOOIfSame(checked) {
        this.certificateRequestDto.shipmentDetailsDTO.finalDestination = null;
        this.certificateRequestDto.shipmentDetailsDTO.finalDestinationCountry = null;

        // this.shippingDetail.fromStation = address.name;
        // this.shippingDetail.fromStationCountry =

        if (checked && this.certificateRequestDto.shipmentDetailsDTO.podPortCountry && (this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace == TdisConstants.MeansOfConveyance.VESSEL)) {
            this.certificateRequestDto.shipmentDetailsDTO.finalDestination = this.certificateRequestDto.shipmentDetailsDTO.podPortCountry;
            this.certificateRequestDto.shipmentDetailsDTO.finalDestinationCountry = this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2;
            this.disableNext3 = false;
        }
        else {
            this.disableNext3 = true;
            this.isaddressDisabled = false;
        }

    }

    checkForVoyegaNumberEnabled() {

        this.certificateService.findVoyageNumberEnabled().subscribe((res) => {
            if (res) {
                this.isVoyageNoEnabled = res.body.payload;
                // this.shippingDetail.voyageNumber='';
            }
        });

    }


    polChange() {
        this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = null;
        this.certificateRequestDto.shipmentDetailsDTO.polPortCountryIso2 = null;
        this.certificateRequestDto.shipmentDetailsDTO.polPortCountryPlaceId = null;
        this.certificateRequestDto.shipmentDetailsDTO.polStateAbbreviation = null;
        this.isPolCountryAddressDisabled = false;
        this.polUnknownCountry = [];
        this.polStateObj = null;
        this.isPolStateEnabled = false;
    }

    podChange() {
        this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = null;
        this.certificateRequestDto.shipmentDetailsDTO.podPortCountryIso2 = null;
        this.certificateRequestDto.shipmentDetailsDTO.podPortCountryPlaceId = null;
        this.certificateRequestDto.shipmentDetailsDTO.podStateAbbreviation = null;
        this.isPodCountryAddressDisabled = false;
        this.podUnknownCountry = []
        this.podStateObj = null;
        this.isPodStateEnabled = false;
    }

    getStatesByCountryId(id) {

        this.countryService.getStatesByCountryId(id).subscribe(res => {
            this.states = res.body;
        });
    }

    handlePolStateChange(selectedState) {
        this.certificateRequestDto.shipmentDetailsDTO.polStateAbbreviation = selectedState.name;
    }

    handlePodStateChange(selectedState) {
        this.certificateRequestDto.shipmentDetailsDTO.podStateAbbreviation = selectedState.name;
    }

    onPolCountryDeselect() {
        this.polStateObj = null;
        this.certificateRequestDto.shipmentDetailsDTO.polStateAbbreviation = null;
        this.certificateRequestDto.shipmentDetailsDTO.polPortCountry = null;
        this.isPolStateEnabled = false;
    }

    onPodCountryDeselect() {
        this.podStateObj = null;
        this.certificateRequestDto.shipmentDetailsDTO.podStateAbbreviation = null;
        this.certificateRequestDto.shipmentDetailsDTO.podPortCountry = null;
        this.isPodStateEnabled = false;
    }

    getCountry(country: any) {
        return this.countries.find(cn => cn.name == country);
    }

    getCargoSumInsuredLimitFromPolicy() {
        let clientId;
        // if (this.brokerCertificateService.clientDto != null) {
        if (CommonUtils.isNotNil(this.brokerCertificateService.clientDto)) {
            clientId = this.brokerCertificateService.clientDto.id;
        } else {
            let clientInfo = this.stateStorageService.getClientDTO();
            // if (typeof clientInfo === "string") {
            if (CommonUtils.isString(clientInfo)) {
                clientInfo = JSON.parse(this.stateStorageService.getClientDTO());
            }
            clientId=clientInfo!=null? clientInfo.id:this.account.id;
            if(RoleUtil.checkForClient(this.principal.authority)) {
                clientId=this.principal.userIdentity.policyHolderId;
            }
        }

        if(CommonUtils.isNil(clientId) || CommonUtils.isNil(this.certificateRequestDto!.shipmentDetailsDTO!.dateOfShipment)) return;

        this.certificateService.getCargoSumInsuredLimitFromPolicyForBulk(clientId, this.certificateRequestDto!.shipmentDetailsDTO!.dateOfShipment).subscribe(res => {
            if (res && res.body) {
                if (res.body.payload) {
                    this.sumInsuredLimitInCargoDetails = res.body.payload;
                    if (this.sumInsuredLimitInCargoDetails < Number(this.certificateRequestDto.cargoDetailsDTO.percentageCover)) {
                        this.certificateRequestDto.cargoDetailsDTO.percentageCover = this.sumInsuredLimitInCargoDetails + "";
                    }
                } else {
                    this.sumInsuredLimitInCargoDetails = 110;
                }
                this.addSumInsuredValue();

                this.cargoSamInsuredData = [];
                for (let i = 100; i <= this.sumInsuredLimitInCargoDetails.sumInsuredLimit; i = i + 10) {
                    this.cargoSamInsuredData.push(i);
                    // console.log(this.cargoSamInsuredData, "select Data for Cargo");
                }
                if(this.sumInsuredLimitInCargoDetails.sumInsuredLimit > 100) {
                    this.cargoSamInsuredData.splice(1, 0, 102);
                    this.cargoSamInsuredData.splice(2, 0, 105);

                }
            } else {
                this.sumInsuredLimitInCargoDetails = 110;
            }
        })
    }

  vesselUnknownMandatory: boolean = false;
  isVesselUnknownOrMandatory(e: any) {
    // this.vesselUnknownMandatory = e.target.checked;
    this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown = e.target.checked;
    console.warn(this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown);


    if(this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown) {
        this.certificateRequestDto.shipmentDetailsDTO.vesselName = null;
        this.certificateRequestDto.shipmentDetailsDTO.meansOfConveyanceNumber = null;
        this.certificateRequestDto.shipmentDetailsDTO.voyageNumber = null;
        // this.isVesselName = true;
        // this.isVesselName = null;
        this.vesselImoOrNameOrUnknownValue="unknown";
      }

  }

  hideVesselMandatoryModal() {
    this.vesselMandatoryModal.hide();
    $(document.body).removeClass("modal-open");
    // this._renderer.removeClass(document.body, "modal-open");
  }

  showVesselMandatoryModal() {
    this.vesselMandatoryModal.show();
  }

  confirmVesselMandatoryModal() {
    if(this.vesselUnknownMandatory) {
        this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown = true;
    }
    this.hideVesselMandatoryModal();
    this.save();
  }

  showVesselOptionalModal() {
    this.vesselOptionalModal.show();
  }

  hideVesselOptionalModal(){
    this.vesselOptionalModal.hide();
    $(document.body).removeClass("modal-open");
    // this._renderer.removeClass(document.body, "modal-open");
  }

  confirmVesselOptionalModal() {
    if(this.vesselUnknownMandatory) {
    //   this.shippingDetail.isVesselUnknown = true;
      this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown = true;
    }
    this.hideVesselOptionalModal();
    this.save();
  }

  vesselUnknownMandatoryOptionalModals() {
    // if(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === 'VESSEL' && this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && this.principal.userIdentity.isVesselNameOrImoMandatory) {
    if(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL && this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && this.isVesselNameOrImoMandatoryEnabled) {
        this.showVesselMandatoryModal();
    // } else if(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === 'VESSEL' && this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && !this.principal.userIdentity.isVesselNameOrImoMandatory) {
    } else if(this.certificateRequestDto.shipmentDetailsDTO.meansOfConveynace === TdisConstants.MeansOfConveyance.VESSEL && this.certificateRequestDto.shipmentDetailsDTO.isVesselUnknown && !this.isVesselNameOrImoMandatoryEnabled) {
        this.showVesselOptionalModal();
    } else {
        this.save();
    }

  }

  checkForVesselNameOrImoMandatoryEnabled(){
    this.certificateService.findVesselNameOrImoMandatoryEnabled().subscribe((res)=>{
      if(res){
        this.isVesselNameOrImoMandatoryEnabled = res.body.payload ;
      }
    });

  }
}

